module.exports = __webpack_public_path__ + "static/img/39-北京科技大学附属中学.9ba7278.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/39-北京科技大学附属中学.png
// module id = M91+
// module chunks = 0